import { gql } from '@urql/core';

export const GET_GIFT_CARDS = gql`
  query GetGiftCards($options: GiftCardListOptions) {
    giftCards(options: $options) {
      items {
        id
        code
        status
        initialBalance
        currentBalance
        purchaserCustomerId
        sourceOrderId
        recipientEmail
        recipientName
        issuanceType
        deliveryMethod
        isDelivered
        expiresAt
        createdAt
      }
      totalItems
    }
  }
`;

export const GET_GIFT_CARD = gql`
  query GetGiftCard($id: ID!) {
    giftCard(id: $id) {
      id
      code
      status
      initialBalance
      currentBalance
      purchaserCustomerId
      sourceOrderId
      sourceOrderLineId
      recipientEmail
      recipientPhone
      recipientName
      giftMessage
      expiresAt
      issuanceType
      issuedByAdminId
      deliveryMethod
      isDelivered
      createdAt
      updatedAt
    }
  }
`;

export const GET_GIFT_CARD_TRANSACTIONS = gql`
  query GetGiftCardTransactions($giftCardId: ID!, $options: GiftCardTransactionListOptions) {
    giftCardTransactions(giftCardId: $giftCardId, options: $options) {
      items {
        id
        type
        amount
        balanceAfter
        description
        orderId
        adminId
        createdAt
      }
      totalItems
    }
  }
`;

export const GET_GIFT_CARD_SUMMARY = gql`
  query GetGiftCardSummary {
    giftCardSummary {
      totalCards
      activeCards
      usedCards
      expiredCards
      disabledCards
      totalOutstandingBalance
      totalIssuedBalance
    }
  }
`;

export const GET_GIFT_CARD_FULL_CODE = gql`
  query GetGiftCardFullCode($id: ID!) {
    giftCardFullCode(id: $id)
  }
`;

export const GET_GIFT_CARD_SETTINGS = gql`
  query GetGiftCardSettings {
    giftCardSettings {
      id
      enabled
      defaultExpiryDays
      minDenomination
      maxDenomination
      allowCustomAmount
      maxCardsPerOrder
      denominations
    }
  }
`;

export const ISSUE_GIFT_CARD = gql`
  mutation IssueGiftCard($input: IssueGiftCardInput!) {
    issueGiftCard(input: $input) {
      id
      code
      status
      initialBalance
      currentBalance
      deliveryMethod
      createdAt
    }
  }
`;

export const DISABLE_GIFT_CARD = gql`
  mutation DisableGiftCard($id: ID!) {
    disableGiftCard(id: $id) {
      id
      status
    }
  }
`;

export const ENABLE_GIFT_CARD = gql`
  mutation EnableGiftCard($id: ID!) {
    enableGiftCard(id: $id) {
      id
      status
    }
  }
`;

export const DELIVER_GIFT_CARD = gql`
  mutation DeliverGiftCard($id: ID!) {
    deliverGiftCard(id: $id) {
      id
      isDelivered
      deliveryMethod
      updatedAt
    }
  }
`;

export const ADJUST_GIFT_CARD_BALANCE = gql`
  mutation AdjustGiftCardBalance($id: ID!, $amount: Int!, $note: String!, $idempotencyKey: String!) {
    adjustGiftCardBalance(id: $id, amount: $amount, note: $note, idempotencyKey: $idempotencyKey) {
      id
      currentBalance
      status
    }
  }
`;

export const UPDATE_GIFT_CARD_SETTINGS = gql`
  mutation UpdateGiftCardSettings($input: UpdateGiftCardSettingsInput!) {
    updateGiftCardSettings(input: $input) {
      id
      enabled
      defaultExpiryDays
      minDenomination
      maxDenomination
      allowCustomAmount
      maxCardsPerOrder
      denominations
    }
  }
`;
